import { render, staticRenderFns } from "./CmgLeaderboardSideQuest.vue?vue&type=template&id=6d4c80d8&scoped=true&lang=pug"
import script from "./cmg-leaderboard-side-quest.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-side-quest.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardSideQuest.vue?vue&type=style&index=0&id=6d4c80d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c80d8",
  null
  
)

export default component.exports